<template>
  <a-modal
    :title="title"
    centered
    :width="500"
    :mask-closable="false"
    :visible="showCheckCloseProjectForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <template>

            <a-form-model-item label="是否检测" prop="check_close_project" help="开启后，系统会自动关停当日有消耗且没有绑定共享钱包的广告主项目；关闭则不检测。">
              <a-switch v-model="model.check_close_project"/>
            </a-form-model-item>
          </template>

        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'CheckCloseProject';
</style>

<script>
import CheckCloseProject from './CheckCloseProject'
export default CheckCloseProject
</script>
